import { Button } from "@msuite/ui/button";
import { useDisclosure } from "@msuite/ui/hooks";
import { Icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { ModalWrapper } from "@msuite/ui/modal";
import { useQueryClient } from "@msuite/ui/query";
import type { DataTableMenuProps } from "@msuite/ui/table";
import React from "react";
import { AddWorkspaceModal } from "@/modals/organizations/add-workspace-modal";

export function WorkspacesMenu({ queryKey }: DataTableMenuProps) {
	/** Hooks */
	const { t } = useTranslation();
	const addWorkspaceModal = useDisclosure();
	const qc = useQueryClient();

	/** Functions */
	async function handleOnAddWorkspaceComplete() {
		await qc.invalidateQueries({
			queryKey,
		});
	}

	/** Render */
	return (
		<React.Fragment>
			<Button
				icon={<Icon name="Plus" />}
				variant="primary"
				onClick={addWorkspaceModal.onOpen}
				data-cy="add-workspace-button"
			>
				{t("organization.add_workspace")}
			</Button>
			<ModalWrapper>
				{addWorkspaceModal.isOpen && (
					<AddWorkspaceModal
						isOpen={addWorkspaceModal.isOpen}
						onClose={addWorkspaceModal.onClose}
						onComplete={handleOnAddWorkspaceComplete}
					/>
				)}
			</ModalWrapper>
		</React.Fragment>
	);
}
